import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Sector, SectorDTO } from '../../models/sector.interface';
import { Pagination } from '../../models/pagination.interface';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { QueryGet } from '../../types/query-types';
import { environment } from '../../../../environments/environment';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { RequestService } from '../request/request';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class SectorService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'sectors/';
  url = environment.service_1 + 'all-sectors/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedsector = new BehaviorSubject<Sector | null>(null);
  selectedsector$ = this.selectedsector.asObservable();

  private sectors = new BehaviorSubject<Sector[]>([]);
  sectors$ = this.sectors.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setSector(sector: Sector) {
    this.selectedsector.next(sector);
  }

  setSectors(sectors: Sector[]) {
    this.sectors.next(sectors);
  }

  removeSectorSelected() {
    this.selectedsector.next(null);
  }

  createSector(sector: SectorDTO) {
    return this.http.post<Sector>(this.urlPath, sector).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateSector(id: number, sector: SectorDTO & { id: number }) {
    return this.http.put<Sector>(this.urlPath + id + '/', sector).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getSector(query: QueryGet): Observable<Pagination<Sector[]>> {
    return this.requestService.get<Sector[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getSectors(): Observable<Sector[]> {
    return this.http.get<Sector[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionSector(sector: Sector[]): OptionSelect[] {
    return sector.map((item: Sector) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
